/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class HealthClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/v1/health';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDetailed: (
        ): string => {
            let clientRequestUrl = '/v1/health/details';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLiveness: (
        ): string => {
            let clientRequestUrl = '/v1/health/liveness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getReadiness: (
        ): string => {
            let clientRequestUrl = '/v1/health/readiness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Health status
     * @return OK
     */
    get(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get Health detailed status
     * @return OK
     */
    getDetailed(): Promise<HealthStatusReportDetailed> {
        const clientRequestUrl = this.baseUrl + this.routes.getDetailed(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReportDetailed>(_response, false, ['executionDateTimeUtc']);
        });
    }

    /**
     * Get liveness
     * @return OK
     */
    getLiveness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getLiveness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get readiness
     * @return OK
     */
    getReadiness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getReadiness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }
}

export class PopsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getUserAccess: (
			popsIdentifier?: string | undefined,
        ): string => {
            let clientRequestUrl = '/v1/pops/access?';
            if (popsIdentifier === null) {
                throw new Error('The parameter "popsIdentifier" cannot be null.');
            } else if (popsIdentifier !== undefined) {
                clientRequestUrl += 'popsIdentifier=' + encodeURIComponent('' + popsIdentifier) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getApplicationProfiles: (
			popsIdentifier?: string | undefined,
        ): string => {
            let clientRequestUrl = '/v1/pops/applicationprofiles?';
            if (popsIdentifier === null) {
                throw new Error('The parameter "popsIdentifier" cannot be null.');
            } else if (popsIdentifier !== undefined) {
                clientRequestUrl += 'popsIdentifier=' + encodeURIComponent('' + popsIdentifier) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Pops User Access Detail
     * @param popsIdentifier (optional) popsIdentifier of the Service
     * @return OK
     */
    getUserAccess(popsIdentifier?: string | undefined): Promise<PopsUserAccessDetailsProvider> {
        const clientRequestUrl = this.baseUrl + this.routes.getUserAccess(
            popsIdentifier,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<PopsUserAccessDetailsProvider>(_response, false, []);
        });
    }

    /**
     * Get Pops Application Profile
     * @param popsIdentifier (optional) ServiceKey of the Service
     * @return OK
     */
    getApplicationProfiles(popsIdentifier?: string | undefined): Promise<PopsApplicationProfilesProvider> {
        const clientRequestUrl = this.baseUrl + this.routes.getApplicationProfiles(
            popsIdentifier,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<PopsApplicationProfilesProvider>(_response, false, []);
        });
    }
}

export class RequestsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        createFormRequest: (
        ): string => {
            let clientRequestUrl = '/v1/requests/form';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        createDemoFormRequest: (
        ): string => {
            let clientRequestUrl = '/v1/requests/demo-form';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        createRequest: (
        ): string => {
            let clientRequestUrl = '/v1/requests';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchRequest: (
			from?: string | undefined,
			to?: string | undefined,
			serviceKeys?: string | undefined,
			emails?: string | undefined,
			icIds?: string | undefined,
			page?: number | undefined,
			pageSize?: number | undefined,
        ): string => {
            let clientRequestUrl = '/v1/requests?';
            if (from === null) {
                throw new Error('The parameter "from" cannot be null.');
            } else if (from !== undefined) {
                clientRequestUrl += 'from=' + encodeURIComponent('' + from) + '&';
            }
            if (to === null) {
                throw new Error('The parameter "to" cannot be null.');
            } else if (to !== undefined) {
                clientRequestUrl += 'to=' + encodeURIComponent('' + to) + '&';
            }
            if (serviceKeys === null) {
                throw new Error('The parameter "serviceKeys" cannot be null.');
            } else if (serviceKeys !== undefined) {
                clientRequestUrl += 'serviceKeys=' + encodeURIComponent('' + serviceKeys) + '&';
            }
            if (emails === null) {
                throw new Error('The parameter "emails" cannot be null.');
            } else if (emails !== undefined) {
                clientRequestUrl += 'emails=' + encodeURIComponent('' + emails) + '&';
            }
            if (icIds === null) {
                throw new Error('The parameter "icIds" cannot be null.');
            } else if (icIds !== undefined) {
                clientRequestUrl += 'icIds=' + encodeURIComponent('' + icIds) + '&';
            }
            if (page === null) {
                throw new Error('The parameter "page" cannot be null.');
            } else if (page !== undefined) {
                clientRequestUrl += 'page=' + encodeURIComponent('' + page) + '&';
            }
            if (pageSize === null) {
                throw new Error('The parameter "pageSize" cannot be null.');
            } else if (pageSize !== undefined) {
                clientRequestUrl += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        createPopsRequest: (
        ): string => {
            let clientRequestUrl = '/v1/requests/pops';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Create Request Access with the entire form
     * @param body (optional) RequestFormQuery Content
     * @return OK
     */
    createFormRequest(body?: RequestFormQuery | undefined): Promise<RequestResult> {
        const clientRequestUrl = this.baseUrl + this.routes.createFormRequest(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RequestResult>(_response, false, []);
        });
    }

    /**
     * Create Request Demo with the entire form
     * @param body (optional) RequestDemoFormQuery Content
     * @return OK
     */
    createDemoFormRequest(body?: RequestDemoFormQuery | undefined): Promise<RequestResult> {
        const clientRequestUrl = this.baseUrl + this.routes.createDemoFormRequest(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RequestResult>(_response, false, []);
        });
    }

    /**
     * Create Request Access
     * @param body (optional) Request Content
     * @return OK
     */
    createRequest(body?: RequestQuery | undefined): Promise<RequestResult> {
        const clientRequestUrl = this.baseUrl + this.routes.createRequest(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RequestResult>(_response, false, []);
        });
    }

    /**
     * Search Request Access
     * @param from (optional) specific start period with format **YYYY-MM-DD**
     * @param to (optional) specific end period with format **YYYY-MM-DD**
     * @param serviceKeys (optional) Comma separated list of service key
     * @param emails (optional) Comma separated list of contact email
     * @param icIds (optional) Comma separated list of contact id
     * @param page (optional) Page of result (_default value: 1_)
     * @param pageSize (optional) Max content per Page (_default value: 100_)
     * @return OK
     */
    searchRequest(from?: string | undefined, to?: string | undefined, serviceKeys?: string | undefined, emails?: string | undefined, icIds?: string | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<RequestSearchResult> {
        const clientRequestUrl = this.baseUrl + this.routes.searchRequest(
            from,
            to,
            serviceKeys,
            emails,
            icIds,
            page,
            pageSize,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RequestSearchResult>(_response, false, ['requestDate']);
        });
    }

    /**
     * Create Pops Request Access
     * @param body (optional) Pops Request Content
     * @return OK
     */
    createPopsRequest(body?: PopsRequestProvider | undefined): Promise<RequestResult> {
        const clientRequestUrl = this.baseUrl + this.routes.createPopsRequest(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RequestResult>(_response, false, []);
        });
    }
}

export class RequestUsersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getRequestUser: (
			icId: string,
        ): string => {
            let clientRequestUrl = '/v1/request-users/{icId}';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get User by IcId
     * @param icId User IcId
     * @return OK
     */
    getRequestUser(icId: string): Promise<UserResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getRequestUser(
            icId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<UserResult>(_response, false, []);
        });
    }
}

export class ServicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getService: (
			ressourceId: string,
        ): string => {
            let clientRequestUrl = '/v1/services/{ressourceId}';
            if (ressourceId === undefined || ressourceId === null) {
                throw new Error('The parameter "ressourceId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{ressourceId}', encodeURIComponent('' + ressourceId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchService: (
			ressourceId?: string | undefined,
			url?: string | undefined,
        ): string => {
            let clientRequestUrl = '/v1/services?';
            if (ressourceId === null) {
                throw new Error('The parameter "ressourceId" cannot be null.');
            } else if (ressourceId !== undefined) {
                clientRequestUrl += 'ressourceId=' + encodeURIComponent('' + ressourceId) + '&';
            }
            if (url === null) {
                throw new Error('The parameter "url" cannot be null.');
            } else if (url !== undefined) {
                clientRequestUrl += 'url=' + encodeURIComponent('' + url) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Service
     * @param ressourceId Service resource Id
     * @return OK
     */
    getService(ressourceId: string): Promise<Service> {
        const clientRequestUrl = this.baseUrl + this.routes.getService(
            ressourceId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Service>(_response, false, []);
        });
    }

    /**
     * Search Service
     * @param ressourceId (optional) Service Resource Id
     * @param url (optional) Service Url
     * @return OK
     */
    searchService(ressourceId?: string | undefined, url?: string | undefined): Promise<Service> {
        const clientRequestUrl = this.baseUrl + this.routes.searchService(
            ressourceId,
            url,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Service>(_response, false, []);
        });
    }
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

export interface HealthCheckReportEntryDetailed {
    name?: string | undefined;
    status: HealthStatus;
    type?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    data?: { [key: string]: any; } | undefined;
    problems?: Problem[] | undefined;
}

export enum HealthStatus {
    Unhealthy = "unhealthy",
    Degraded = "degraded",
    Healthy = "healthy",
}

export interface HealthStatusReport {
    status: HealthStatus;
}

export interface HealthStatusReportDetailed {
    status: HealthStatus;
    executionDateTimeUtc: Date;
    apiCode?: string | undefined;
    checks?: HealthCheckReportEntryDetailed[] | undefined;
}

export interface IamResourceProfile {
    id?: string | undefined;
    name?: string | undefined;
    exposure?: string | undefined;
}

export interface PopsApplicationProfilesAnalyticParam {
    name?: string | undefined;
    display?: string | undefined;
    required?: boolean | undefined;
    profiles?: string[] | undefined;
    type?: string | undefined;
    values?: PopsApplicationProfilesAnalyticParamValue[] | undefined;
}

export interface PopsApplicationProfilesAnalyticParamValue {
    status?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface PopsApplicationProfilesProfile {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
}

export interface PopsApplicationProfilesProvider {
    resultStatus?: string | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    profiles?: PopsApplicationProfilesProfile[] | undefined;
    additionalInfo?: PopsApplicationProfilesAnalyticParam[] | undefined;
}

export interface PopsParamsRequestProvider {
    name?: string | undefined;
    values?: string[] | undefined;
}

export interface PopsRequestProvider {
    serviceName?: string | undefined;
    profiles?: string[] | undefined;
    params?: PopsParamsRequestProvider[] | undefined;
    comments?: string | undefined;
}

export interface PopsUserAccessDetailsProvider {
    resultStatus?: string | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    status?: string | undefined;
    needsProfile?: boolean | undefined;
    needsAnalyticalParam?: boolean | undefined;
    deployedInPops?: boolean | undefined;
    commentDescription?: string | undefined;
    commentRequired?: boolean | undefined;
}

export interface Problem {
    detail?: string | undefined;
}

export interface RequestDemoFormQuery {
    serviceKey?: string | undefined;
    details?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    professionalPhoneNumber?: string | undefined;
    representativeEmail?: string | undefined;
    returnUrl?: string | undefined;
    sourceUrl?: string | undefined;
    sourceContext?: string | undefined;
    requestFormLanguage?: string | undefined;
}

export interface RequestFormContentModel {
    id: number;
    requestId: number;
    email?: string | undefined;
    requestDate?: Date | undefined;
    serviceKey?: string | undefined;
    url?: string | undefined;
    country?: string | undefined;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    isMifid2Eligible?: boolean | undefined;
    representative?: string | undefined;
    request?: RequestModel | undefined;
    siren?: string | undefined;
    clientReference?: string | undefined;
    professionalPhoneNumber?: string | undefined;
}

export interface RequestFormQuery {
    serviceKey?: string | undefined;
    details?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    professionalPhoneNumber?: string | undefined;
    representativeEmail?: string | undefined;
    returnUrl?: string | undefined;
    sourceUrl?: string | undefined;
    sourceContext?: string | undefined;
    requestFormLanguage?: string | undefined;
    country?: string | undefined;
    companyAddress?: string | undefined;
    siren?: string | undefined;
    clientReference?: string | undefined;
    jobTitle?: string | undefined;
    isMifid2Eligible?: boolean | undefined;
    representativeDetails?: string | undefined;
}

export interface RequestModel {
    id: number;
    comment?: string | undefined;
    email?: string | undefined;
    icId?: string | undefined;
    requestDate?: Date | undefined;
    serviceKey?: string | undefined;
    popsId?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
    requestFormContent?: RequestFormContentModel | undefined;
}

export interface RequestQuery {
    serviceKey?: string | undefined;
    comment?: string | undefined;
    icId?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    sourceUrl?: string | undefined;
    sourceContext?: string | undefined;
    resourceProfiles?: IamResourceProfile[] | undefined;
}

export interface RequestResult {
    message?: string | undefined;
}

export interface RequestSearchResult {
    data?: RequestModel[] | undefined;
    prev: boolean;
    next: boolean;
}

export interface Scope {
    isInternal: boolean;
}

export interface Service {
    url?: string | undefined;
    serviceKey?: string | undefined;
    ressourceId?: string | undefined;
    popsIdentifier?: string | undefined;
    name?: string | undefined;
    onBoardingContacts?: string | undefined;
    activateIAMAccessWidget: boolean;
    category?: string | undefined;
    infoUrl?: string | undefined;
    resourceProfiles?: IamResourceProfile[] | undefined;
}

export interface UserResult {
    id?: string | undefined;
    lastname?: string | undefined;
    firstname?: string | undefined;
    isActive: boolean;
    scope?: Scope | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}